module.exports = __webpack_public_path__ + "img/upload.414f4f24.svg";